export default "__VITE_PUBLIC_ASSET__5f71c165__"